module.exports = __webpack_public_path__ + "img/pause.ea8cc1fe.svg";